export const root = "r1m666ag";
export const attachmentsWrapper = "a2klazn";
export const attachmentsTitle = "a1v0p5ga";
export const attachmentsDescription = "auyamq3";
export const notes = "ncj07t1";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");